<template>
  <Row id="PageContent">
    <Col :span="24" class="content">
      <Row :gutter="[16,32]">
        <Col :span="24" >
          <Form :model="searchForm">
            <!-- <Row :gutter="16">
              <Col :span="6">
                <FormItem :label="$t('userFee.field.idChaPoi')" name="idChaPoi">
                  <Input :placeholder="$t('userFee.validate.required.idChaPoi')" v-model:value="searchForm.idChaPoi"></Input>
                </FormItem>
              </Col>
              <Col :span="6">
                <FormItem :label="$t('userFee.field.idSpa')" name="idSpa">
                  <Input :placeholder="$t('userFee.validate.required.idSpa')" v-model:value="searchForm.idSpa"></Input>
                </FormItem>
              </Col>
              <Col :span="6">
                <FormItem :label="$t('userFee.field.feeAmount')" name="feeAmount">
                  <Input :placeholder="$t('ususerFeeer.validate.required.feeAmount')" v-model:value="searchForm.feeAmount"></Input>
                </FormItem>
              </Col>
              <Col :span="6">
                <FormItem :label="$t('userFee.field.startMonth')" name="startMonth">
                  <Input :placeholder="$t('userFee.validate.required.startMonth')" v-model:value="searchForm.startMonth"></Input>
                </FormItem>
              </Col>
              <Col :span="6">
                <FormItem :label="$t('userFee.field.idUse')" name="idUse">
                  <Input :placeholder="$t('userFee.validate.required.idUse')" v-model:value="searchForm.idUse"></Input>
                </FormItem>
              </Col>
            </Row> -->
            <Row style="margin-bottom: 5px">
              <Col :span="8" :offset="8" style="text-align: right;">
                <Button type="primary" @click="search_submit">{{ $t('public.name.search') }}</Button>
                <span>&nbsp;</span>
                <Button @click="search_reset">{{ $t('public.name.reset') }}</Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <div>
        <Table :columns="columns" :dataSource="list" :scroll="{x: 1500}" rowKey="idUseFee" :loading="loading" :pagination="tablePagination" @change="chang_page">
          <!-- 标题插槽-->
          <template #headerCell="{ column }">
            <template v-if="column.dataIndex === 'action'">
              <span>
                {{$t("public.table.action")}}
                <Button v-if="checkPermission('UserFeeManage.Add')" type="primary" size="small" shape="circle" @click="add()">
                  <PlusOutlined />
                </Button>
              </span>
            </template>
          </template>

          <!-- 内容插槽-->
          <template #bodyCell="{column, record}">
            <template v-if="column.dataIndex === 'action'">
              <div class="pc-display">
                <a @click="detail(record)">
                  {{ $t("public.name.detail") }}
                </a>
                <!-- <Divider type="vertical"/>
                <a @click="edit(record)">
                  {{ $t("public.name.edit") }}
                </a> -->
              </div>
            </template>
          </template>
        </Table>
      </div>
    </Col>
    <UserFeeDetail ref="refUserFeeDetail"></UserFeeDetail>
    <UserFeeEdit ref="refUserFeeEdit" @updateList="get_list"></UserFeeEdit>
  </Row>
</template>
<script>
export default {
  name: "UserFeeManage",
}
</script>
<script setup>
import {createVNode, reactive, ref, toRefs} from "vue";
import { Row, Col, Table, Tag, Button, Dropdown, Menu, MenuItem, Modal, Form, FormItem, Input, message, Divider, Upload} from "ant-design-vue";
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons-vue";
import {UserFeeList} from "@/api/userFee";
import UserFeeDetail from "./UserFeeDetail";
import UserFeeEdit from "./UserFeeEdit";
import moment from "moment";
import {useI18n} from "vue-i18n";
import {useStore} from "vuex";

const i18n = useI18n()
const store = useStore()

const refUserFeeEdit = ref()
const refUserFeeDetail = ref()

const columns = [
  { title: i18n.t("userFee.table.id_use_fee"), width: 60, ellipsis: true, fixed: "left", dataIndex: "idUseFee", key: "idUseFee" },
  { title: i18n.t("userFee.table.id_cha_poi"), width: 180, ellipsis: true, dataIndex: "chargeBoxId", key: "chargeBoxId" },
  { title: i18n.t("userFee.table.id_use"), width: 180, ellipsis: true, dataIndex: "account", key: "account",},
  { title: i18n.t("userFee.table.id_spa"), width: 180, ellipsis: true, dataIndex: "nameZh", key: "nameZh",},
  { title: i18n.t("userFee.table.fee_amount"), width: 180, ellipsis: true, dataIndex: "feeAmount", key: "feeAmount" },
  { title: i18n.t("userFee.table.start_month"), width: 90, ellipsis: true, dataIndex: "startMonth", key: "startMonth" },
  { key: "action", width: 120, ellipsis: true, fixed: "right", dataIndex: "action"},
]

let loading = ref(false)
let list = ref([])
const data = reactive({
  searchForm: {},
  tablePagination: {
    pageSizeOptions: ["10", "20", "50", "100"],
    showSizeChanger: true,
    current: 1,
    pageSize: 10,
    total: 0,
  },
})
const {searchForm, tablePagination} = toRefs(data)

function chang_page(pagination) {
  tablePagination.value = pagination;
  get_list();
}

function get_list() {
  loading.value = true;
  const api = new UserFeeList();
  const getData = {
    page: tablePagination.value.current,
    limit: tablePagination.value.pageSize,
    ...searchForm.value
  }
  api.get(getData).then((response) => {
    loading.value = false;
    if (0 === parseInt(response.data.code)) {
      const dataTmp = response.data.data;
      tablePagination.value.current = parseInt(dataTmp.current);
      tablePagination.value.pageSize = parseInt(dataTmp.pageSize);
      tablePagination.value.total = parseInt(dataTmp.total);
      list.value = dataTmp.data;
    } else {
      list.value = [];
    }
  });
}

function add() {
  refUserFeeEdit.value?.addShow();
}

function detail(obj) {
  refUserFeeDetail.value?.detailShow(obj);
}

function edit(obj) {
  refUserFeeEdit.value.editShow(obj);
}




function search_submit() {
  tablePagination.value.current = 1
  get_list()
}

function search_reset() {
  tablePagination.current = 1
  searchForm.value = {}
  get_list()
}

// store.commit("setPageTitle", i18n.t('nav.name.UserManage'))
get_list()

defineExpose({
  get_list
})
</script>

<style lang="less">
@import url("style.less");
</style>
